import { HomeHero, Capabilities, MarketsTeaser, CategoriesGrid } from "@/components/site/HomeSections";
import {
  GlobalMap,
  Initiatives,
  ProcessTimeline,
  Philosophy,
  SupplierChecklist,
  WhyRsc,
  PartnerSection,
} from "@/components/site/Sections";

export default function Home() {
  return (
    <>
      <HomeHero />
      <Capabilities />
      <MarketsTeaser />
      <CategoriesGrid />
      <GlobalMap />
      <Initiatives />
      <ProcessTimeline
        overline="Our Procurement Model"
        title="From International Supplier to Regional Opportunity."
        intro="RSC Imports follows a structured procurement and market-development process designed to identify commercially viable long-term opportunities."
      />
      <Philosophy />
      <SupplierChecklist />
      <WhyRsc />
      <PartnerSection />
    </>
  );
}
